"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _serializer = require("./helpers/serializer");

var _serializer2 = _interopRequireDefault(_serializer);

var _retry = require("./helpers/retry");

var _retry2 = _interopRequireDefault(_retry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CHANNEL_NAME = "data";
var ANSWER_SUFFIX = "-answer";

var WebRTC = function () {
	function WebRTC(config) {
		_classCallCheck(this, WebRTC);

		this.config = config;
	}

	_createClass(WebRTC, [{
		key: "createConnectionWithOffer",
		value: function () {
			var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
				var connection, dataChannel, offer;
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.prev = 0;
								connection = this._createConnection();
								dataChannel = connection.createDataChannel(CHANNEL_NAME);

								this._configureDataChannel(dataChannel);
								_context.next = 6;
								return connection.createOffer();

							case 6:
								offer = _context.sent;
								_context.next = 9;
								return connection.setLocalDescription(offer);

							case 9:
								return _context.abrupt("return", { connection: connection, dataChannel: dataChannel });

							case 12:
								_context.prev = 12;
								_context.t0 = _context["catch"](0);
								throw new Error("Error initializing channel: Cannot create offer");

							case 15:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, this, [[0, 12]]);
			}));

			function createConnectionWithOffer() {
				return _ref.apply(this, arguments);
			}

			return createConnectionWithOffer;
		}()
	}, {
		key: "createConnectionWithAnswer",
		value: function () {
			var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(offer) {
				var connection, answer;
				return regeneratorRuntime.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.prev = 0;
								connection = this._createConnection();
								_context2.next = 4;
								return connection.setRemoteDescription(offer);

							case 4:
								_context2.next = 6;
								return connection.createAnswer();

							case 6:
								answer = _context2.sent;
								_context2.next = 9;
								return connection.setLocalDescription(answer);

							case 9:
								return _context2.abrupt("return", connection);

							case 12:
								_context2.prev = 12;
								_context2.t0 = _context2["catch"](0);
								throw new Error("Error initializing channel: Cannot create answer");

							case 15:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, this, [[0, 12]]);
			}));

			function createConnectionWithAnswer(_x) {
				return _ref2.apply(this, arguments);
			}

			return createConnectionWithAnswer;
		}()
	}, {
		key: "getOffer",
		value: function () {
			var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(channel) {
				var sessionDescription;
				return regeneratorRuntime.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_context3.prev = 0;
								_context3.next = 3;
								return this.store.get(channel.token);

							case 3:
								sessionDescription = _context3.sent;
								return _context3.abrupt("return", _serializer2.default.deserialize(sessionDescription, "offer"));

							case 7:
								_context3.prev = 7;
								_context3.t0 = _context3["catch"](0);
								throw new Error("Error joining channel: Cannot read offer data");

							case 10:
							case "end":
								return _context3.stop();
						}
					}
				}, _callee3, this, [[0, 7]]);
			}));

			function getOffer(_x2) {
				return _ref3.apply(this, arguments);
			}

			return getOffer;
		}()
	}, {
		key: "getAnswer",
		value: function () {
			var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(channel) {
				var sessionDescription;
				return regeneratorRuntime.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								_context4.prev = 0;
								_context4.next = 3;
								return this.store.get(this._getAnswerToken(channel));

							case 3:
								sessionDescription = _context4.sent;
								return _context4.abrupt("return", _serializer2.default.deserialize(sessionDescription, "answer"));

							case 7:
								_context4.prev = 7;
								_context4.t0 = _context4["catch"](0);
								throw new Error("Error joining channel: Cannot read answer data");

							case 10:
							case "end":
								return _context4.stop();
						}
					}
				}, _callee4, this, [[0, 7]]);
			}));

			function getAnswer(_x3) {
				return _ref4.apply(this, arguments);
			}

			return getAnswer;
		}()
	}, {
		key: "saveOffer",
		value: function () {
			var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(connection, channel) {
				var sessionDescription;
				return regeneratorRuntime.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								_context5.prev = 0;
								_context5.next = 3;
								return this._getSessionDescription(connection);

							case 3:
								sessionDescription = _context5.sent;
								_context5.next = 6;
								return this.store.save(channel.token, sessionDescription);

							case 6:
								_context5.next = 11;
								break;

							case 8:
								_context5.prev = 8;
								_context5.t0 = _context5["catch"](0);
								throw new Error("Error initializing channel: Cannot write offer data");

							case 11:
							case "end":
								return _context5.stop();
						}
					}
				}, _callee5, this, [[0, 8]]);
			}));

			function saveOffer(_x4, _x5) {
				return _ref5.apply(this, arguments);
			}

			return saveOffer;
		}()
	}, {
		key: "saveAnswer",
		value: function () {
			var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(connection, channel) {
				var sessionDescription;
				return regeneratorRuntime.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								_context6.prev = 0;
								_context6.next = 3;
								return this._getSessionDescription(connection);

							case 3:
								sessionDescription = _context6.sent;
								_context6.next = 6;
								return this.store.save(this._getAnswerToken(channel), sessionDescription);

							case 6:
								_context6.next = 11;
								break;

							case 8:
								_context6.prev = 8;
								_context6.t0 = _context6["catch"](0);
								throw new Error("Error initializing channel: Cannot write answer data");

							case 11:
							case "end":
								return _context6.stop();
						}
					}
				}, _callee6, this, [[0, 8]]);
			}));

			function saveAnswer(_x6, _x7) {
				return _ref6.apply(this, arguments);
			}

			return saveAnswer;
		}()
	}, {
		key: "setConnectHandler",
		value: function setConnectHandler(connection, dataChannel, channel) {
			this._configureDataChannel(dataChannel);
			dataChannel.buffer = [];

			dataChannel.onmessage = function (e) {
				var data = e.data;
				if (data) dataChannel.buffer.push(data);
			};

			dataChannel.onopen = function () {
				return channel.connect(connection, dataChannel);
			};
		}
	}, {
		key: "setDisconnectHandler",
		value: function setDisconnectHandler(connection, channel) {
			connection.oniceconnectionstatechange = function (e) {
				var state = connection.iceConnectionState;
				var isDisconnected = state === "failed" || state === "disconnected" || state === "closed";
				if (channel.isConnected && isDisconnected) channel.disconnect();
			};
		}
	}, {
		key: "setWaitHandler",
		value: function setWaitHandler(connection, channel) {
			var _this = this;

			(0, _retry2.default)(channel, "$waitAnswer", _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
				var answer;
				return regeneratorRuntime.wrap(function _callee7$(_context7) {
					while (1) {
						switch (_context7.prev = _context7.next) {
							case 0:
								_context7.next = 2;
								return _this.getAnswer(channel);

							case 2:
								answer = _context7.sent;
								_context7.next = 5;
								return connection.setRemoteDescription(answer);

							case 5:
							case "end":
								return _context7.stop();
						}
					}
				}, _callee7, _this);
			})));
		}
	}, {
		key: "_createConnection",
		value: function _createConnection() {
			return new RTCPeerConnection({ iceServers: this.config.iceServers });
		}
	}, {
		key: "_getSessionDescription",
		value: function _getSessionDescription(connection) {
			return new Promise(function (resolve) {
				connection.onicecandidate = function (e) {
					if (e.candidate !== null) return;
					resolve(_serializer2.default.serialize(connection.localDescription));
				};
			});
		}
	}, {
		key: "_getAnswerToken",
		value: function _getAnswerToken(channel) {
			return channel.token + ANSWER_SUFFIX;
		}
	}, {
		key: "_configureDataChannel",
		value: function _configureDataChannel(dataChannel) {
			dataChannel.binaryType = "arraybuffer";
		}
	}, {
		key: "store",
		get: function get() {
			var store = this.config.store;

			if (!store) throw new Error("Store not set, use `.setStore(...)`");

			return store;
		}
	}]);

	return WebRTC;
}();

exports.default = WebRTC;